import * as formik from "formik";
import * as yup from "yup";

import { useEffect, useState } from "react";

import AnamneseAPI from "../../api/AnamneseAPI";
import AppButton from "../../../../../commons/buttons/AppButton";
import AppInputSelectV2 from "../../../../../commons/inputs/AppInputSelectV2";
import AppLinkButton from "../../../../../commons/buttons/AppLinkButton";
import AppLoading from "../../../../../commons/AppLoading";
import CompanyAPI from "../../../../company/CompanyAPI";
import CustomerAPI from "../../../../customer/CustomerAPI";
import FormTemplateAPI from "../../api/FormTemplateAPI";
import HallAppToast from "../../../../../commons/HallAppToast";
import { Modal } from "react-bootstrap";

const formAPI = new FormTemplateAPI();
const companyAPI = new CompanyAPI();
const customerAPI = new CustomerAPI();
const anamneseAPI = new AnamneseAPI();

function AnamneseModal({ closeShow, show }) {
    const [isLoading, setIsLoading] = useState(true); // ✅ começa true e só muda depois das 2 calls
    const [optionsForm, setOptionsForm] = useState([]);
    const [optionsCustomer, setOptionsCustomer] = useState([]);

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function loadData() {
        try {
            setIsLoading(true);

            await Promise.all([
                findAllForms(),
                findAllCustomers()
            ]);
        } catch (_) {
            // se uma der erro, o toast já vai tratar dentro das funções,
            // mas deixei aqui por segurança
            // HallAppToast.genericError();
        } finally {
            setIsLoading(false);
        }
    }

    async function findAllCustomers() {
        try {
            const resp = await customerAPI.getCustomers(companyAPI.getCompanyManagment().id);

            const options =
                resp.data?.map((data) => ({
                    value: data.id,
                    title: data.name,
                    subtitle: data.whatsapp,
                })) || [];

            setOptionsCustomer(options);
        } catch (e) {
            HallAppToast.genericError();
        }
    }

    async function findAllForms() {
        try {
            const resp = await formAPI.list(companyAPI.getCompanyManagment().id);

            const options =
                resp.data?.map((data) => ({
                    value: data.id,
                    title: data.name,
                    subtitle: data.description,
                })) || [];

            setOptionsForm(options);
        } catch (e) {
            HallAppToast.genericError();
        }
    }

    const formikInstance = formik.useFormik({
        initialValues: {
            templateId: "",
            customerId: "",
        },
        validationSchema: yup.object().shape({
            templateId: yup.string().required("Selecione um formulário."),
            customerId: yup.string().required("Selecione um cliente."),
        }),
        onSubmit: async (values) => {
            try {
                setIsLoading(true)
                await anamneseAPI.generate(values);
                HallAppToast.success("Formulário selecionado!");
                closeShow?.();
            } catch (e) {
                HallAppToast.genericError();
            } finally {
                setIsLoading(false)
            }
        },
        enableReinitialize: true,
    });

    const showError =
        !!formikInstance.touched.templateId && !!formikInstance.errors.templateId;

    return (
        <Modal show={show} fullscreen={false} onHide={() => closeShow()} centered>
            <Modal.Header className="custom-close-button" closeButton>
                <Modal.Title style={{ textAlign: "center", fontSize: "15px" }}>
                    ADICIONAR ANAMNESE
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="container">
                    {isLoading ? (
                        <AppLoading />
                    ) : (
                        <>
                            <AppInputSelectV2
                                placeholder="Selecione um formulário"
                                options={optionsForm}
                                name="templateId"
                                value={formikInstance.values.templateId}
                                onChange={(e) => {
                                    formikInstance.handleChange(e);
                                    formikInstance.setFieldTouched("templateId", true, false);
                                }}
                            />

                            <AppInputSelectV2
                                placeholder="Selecione um cliente"
                                options={optionsCustomer}
                                name="customerId"
                                value={formikInstance.values.customerId}
                                onChange={(e) => {
                                    formikInstance.handleChange(e);
                                    formikInstance.setFieldTouched("customerId", true, false);
                                }}
                            />

                            {showError ? (
                                <div
                                    className="text-danger"
                                    style={{ marginTop: "-8px", fontSize: "0.85rem" }}
                                >
                                    {formikInstance.errors.templateId}
                                </div>
                            ) : null}

                            <div style={{ marginTop: 16 }}>
                                <AppButton
                                    name="salvar"
                                    principalColor="#7d4ee0"
                                    onClick={formikInstance.handleSubmit}
                                />

                                <div style={{marginTop: '10px'}}>
                                    <AppLinkButton name="fechar" onClick={() => closeShow()} />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default AnamneseModal;
